import moment from 'moment';
export var setMomentLocale = function () {
    var urlParts = document.location.pathname.substr(1).split('/').filter(Boolean);
    var locale = urlParts.shift();
    if (['en', 'us'].includes(locale !== null && locale !== void 0 ? locale : '')) {
        moment.locale('en');
        return;
    }
    moment.locale('hu');
};
